export enum AppLanguage { en = 'en', de = 'de' }
